// extracted by mini-css-extract-plugin
export default {"container":"ellipse_container__fEQzY","dot":"ellipse_dot__3Nzsy"};